import React, { useEffect, useState } from 'react';
import { Modal } from "react-bootstrap";
import { useDispatch } from 'react-redux';
import toast from 'react-hot-toast';
import CustomSingleSelect, { CustomSingleSelectModel } from '../../../../components/CustomSingleSelect';
import { storeActivityIndicator } from '../../../../redux/reducers/authSlice';
import { OtomatikFaturaKurali, OtomatikFaturaService } from '../../../../services/OtomatikFaturaService';

interface Props {
    kural: OtomatikFaturaKurali | undefined
    onClose: () => void
    onKopyalandi: (yeniId: string, ayniFirma: boolean) => void
}

/**
 * Kurali kopyala (23.10.2026): ayni firmada (baska musteri / PO icin) ya da yetkili olunan baska firmaya. Kopya pasif acilir;
 * baska firmaya kopyada musteri, PO numaralari ve onaylayici o firmada yeniden secilir.
 */
const KopyalaModal = ({ kural, onClose, onKopyalandi }: Props) => {
    const dispatch = useDispatch();
    const seciliFirma = localStorage.getItem('SelectedCompanyId') ?? '';
    const [hedef, setHedef] = useState<CustomSingleSelectModel | undefined>(undefined);

    useEffect(() => {
        if (kural)
            setHedef(undefined);
    }, [kural])

    const kopyala = async () => {
        if (!kural)
            return;

        try {
            dispatch(storeActivityIndicator(true));

            var response = await OtomatikFaturaService.kopyala(kural.otomatikFaturaKuraliId, hedef?.value);

            if (!response.isSuccess) {
                toast.error(response.message ?? '');
                return;
            }

            var ayniFirma = !hedef || hedef.value == seciliFirma;
            toast.success(ayniFirma
                ? 'Kural pasif olarak kopyalandı; müşteri / PO bilgilerini düzenleyip aktif yapın.'
                : `Kural ${hedef?.label} firmasına pasif olarak kopyalandı. O firmaya geçip müşteri, PO ve onaylayıcıyı seçin, sonra aktif yapın.`);
            onKopyalandi(response.data.id, ayniFirma);
        } catch (error: any) {
            toast.error(error);
        } finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <Modal show={!!kural} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Kuralı kopyala</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="text-gray-700"><b>{kural?.ad}</b> kuralının bütün ayarları kopyalanır; kopya <b>pasif</b> açılır.</p>
                <CustomSingleSelect
                    labelText="Hedef firma (boş = bu firma)"
                    selectedValue={hedef}
                    onChange={setHedef}
                    onMenuOpen={() => OtomatikFaturaService.firmalar()}
                    labelName='label'
                    valueName='value'
                />
                <div className="text-muted fs-7 mt-3">Başka firmaya kopyalarken müşteri, PO numaraları ve onaylayıcı o firmaya ait olduğu için boş gelir; kopyayı o firmada düzenleyip aktif yapın.</div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-light" onClick={onClose}>Vazgeç</button>
                <button className="btn btn-sm btn-primary" onClick={kopyala}>Kopyala</button>
            </Modal.Footer>
        </Modal>
    )
}

export default KopyalaModal;
